// extracted by mini-css-extract-plugin
export default {"button":"UploadFontButton_button__5hOEZ","uploadButton":"UploadFontButton_uploadButton__AaJ15"};